module.exports = __webpack_public_path__ + "img/icon_ke+ksvipslt.4520e9e2.png";